var Insured = /** @class */ (function () {
    function Insured(data) {
        this.accountNumber = null;
        this.cuit = null;
        this.documentNumber = null;
        this.documentType = null;
        this.email = null;
        this.firstName = null;
        this.fullName = null;
        this.gender = null;
        this.lastName = null;
        this.personType = null;
        this.phoneNumber = null;
        this.taxIVA = new TaxIVA();
        if (data) {
            Object.assign(this, data);
        }
    }
    return Insured;
}());
export { Insured };
var TaxIVA = /** @class */ (function () {
    function TaxIVA() {
        this.key = '';
        this.name = '';
    }
    return TaxIVA;
}());
